var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "wave",
    width: "100%",
    height: "100%",
    viewBox: "0 0 200 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "gradient-start",
    offset: "0%",
    stopColor: "var(--colour-start)"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "gradient-stop",
    offset: "100%",
    stopColor: "var(--colour-stop)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.034,12.118c23.022,11.151 62.318,17.266 95.646,17.813c35.021,0.574 55.974,-12.514 104.281,-11.723c-19.075,-9.903 -58.653,-17.589 -91.983,-18.08c-37.82,-0.556 -58.892,12.794 -107.944,11.99Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivider);
export default __webpack_public_path__ + "static/media/divider.b168a4998e46d3aed636575a24027d84.svg";
export { ForwardRef as ReactComponent };